// 合并所有 Formily 包为单个 UMD 输出
// 用 ESM 语法导入所有包的完整命名空间

// ef2 & efx 用的
export * as Shared from "@formily/shared";
export * as Reactive from "@formily/reactive";
export * as Validator from "@formily/validator";
export * as Core from "@formily/core";
export * as React from "@formily/react";

// lpm
export * as JsonSchema from "@formily/json-schema";

// ef2 
export * as CoreEffects from "@formily/core/esm/effects";
export * as CoreSharedExternals from "@formily/core/esm/shared/externals";

// ef2 @formily/core/esm/models/*
import { Form } from "@formily/core/esm/models/Form";
import { Field as FieldType } from "@formily/core/esm/models/Field";
import { Query } from "@formily/core/esm/models/Query";
import { Heart } from "@formily/core/esm/models/Heart";
import { Graph } from "@formily/core/esm/models/Graph";
import { LifeCycle } from "@formily/core/esm/models/LifeCycle";
import { ArrayField as ArrayFieldType } from "@formily/core/esm/models/ArrayField";
import { ObjectField as ObjectFieldType } from "@formily/core/esm/models/ObjectField";
import { VoidField as VoidFieldType } from "@formily/core/esm/models/VoidField";

export const CoreEsmModels = {
    Form,
    FieldType,
    Query,
    Heart,
    Graph,
    LifeCycle,
    ArrayFieldType,
    ObjectFieldType,
    VoidFieldType,
};
